const isAnswered = (localAnswer) => !!localAnswer;

const getResumedAnswer = (questionData) => questionData.get('answerText');

export { isAnswered, getResumedAnswer };
